module.exports = __webpack_public_path__ + "static/media/work6.8197cd1a.jpg";